// extracted by mini-css-extract-plugin
module.exports = {"ja":"ActivityResultCard_ja__3XsML","disabled":"ActivityResultCard_disabled__QBCzQ","disable-scroll":"ActivityResultCard_disable-scroll__11Xwj"};